import axios from 'axios';

const FILE_API_BASE = 'https://kycdoc.saralesuvidha.com/SaralKYCDoc';

export const FileUploadService = {
  uploadFiles: async (files, folderName) => {
    if (!files || files.length === 0) return '';

    const JSZip = (await import('jszip')).default;
    const zip = new JSZip();
    const uniqueFileNames = [];

    files.forEach(file => {
      const timestamp = Date.now();
      const random = Math.random().toString(36).substring(2, 8);
      const extension = file.name.split('.').pop();
      const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
      const uniqueName = `${timestamp}_${random}_${nameWithoutExt}.${extension}`;
      
      zip.file(uniqueName, file);
      uniqueFileNames.push(uniqueName);
    });

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const uploadFormData = new FormData();
    uploadFormData.append('file', zipBlob, `${folderName}.zip`);
    
    await axios.post(`${FILE_API_BASE}/upload?root=SaralAssetsFiles&folderName=${folderName}`, uploadFormData);
    return uniqueFileNames.join(',');
  },

  downloadFiles: async (folderName) => {
    const response = await axios.get(`${FILE_API_BASE}/download?root=SaralAssetsFiles&folderName=${folderName}`, {
      responseType: 'blob'
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${folderName}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};